import { Tag, Team } from '@bringg/types';

import {
  DEFAULT_NUMBER_OF_TASKS_ECOMERCE_DEMO,
  DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
  DEFAULT_TASK_CREATE_INTERVAL_SECONDS,
} from 'Consts';
import { createDeliveryFleet } from 'Services';
import { DemoFlows, DemoSettings } from 'Types';

export const getECommerceDemo = (teams: Team[], tags: Tag[]): DemoSettings => ({
  name: 'Delivery Hub + Curbside Simulator',
  demoType: DemoFlows.ECommerce,
  description:
    "This demo simulates an eCommerce checkout process for a retailer that outsources delivery to multiple third-party carriers. \
    The demo flow currently supports gig economy carriers for ASAP, with a placeholder for traditional carriers with longer delivery \
    SLAs. It also supports curbside when selecting 'Pickup' option.",
  demoIncludes: ['Quotes', 'Real-Time Integration', 'Fleet Router', 'ASAP vs parcel', 'Curbside option'],
  fields: [
    {
      name: 'team',
      label: 'Team',
      value: teams[0],
      component: 'select',
      optionLabel: 'name',
      options: teams,
    },
    {
      name: 'tag',
      label: 'Tag',
      value: tags[0],
      component: 'select',
      optionLabel: 'tag',
      options: tags,
    },
    {
      name: 'phone',
      label: 'Phone Number',
      value: {
        short: 'us',
      },
      component: 'phone',
    },
    {
      name: 'assignDriverIntervalSeconds',
      label: 'Time to assign driver and start in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'checkInPickupIntervalSeconds',
      label: 'Time to pickup check-in in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'checkOutPickupIntervalSeconds',
      label: 'Time to pickup check-out in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'checkInDropOffIntervalSeconds',
      label: 'Time to drop off check-in in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'checkOutDropOffIntervalSeconds',
      label: 'Time to drop off check-out in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'finishOrder',
      label: '',
      value: 1,
      component: 'hidden',
    },
    {
      name: 'shouldGenerateBackgroundTasks',
      label: 'Generate background tasks',
      value: true,
      component: 'checkbox',
    },
    {
      name: 'sleepBetweenTasksStatusCreation',
      label: 'Interval between the orders in seconds',
      value: DEFAULT_TASK_CREATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'ordersToBeCreated',
      label: '# of orders to be created',
      value: DEFAULT_NUMBER_OF_TASKS_ECOMERCE_DEMO,
      component: 'input',
    },
  ],
  createTask: createDeliveryFleet,
});
